import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer className="bg-[#4C1D95] text-purple-300 py-6 sm:py-8 px-4 sm:px-6" data-id="element-1">
        <div className="max-w-4xl mx-auto flex flex-col items-center gap-4 sm:flex-row sm:justify-between" data-id="element-2">
          <p className="text-xs sm:text-sm text-center sm:text-left" data-id="element-3">
            © {new Date().getFullYear()} Sanar en Movimiento. Todos los
            derechos reservados.
          </p>

          <div className="flex items-center gap-4 sm:gap-6" data-id="element-4">
            <button onClick={() => setPrivacyOpen(true)} className="text-xs sm:text-sm hover:text-white active:text-purple-100 transition-colors underline-offset-4 hover:underline py-1" data-id="element-5">
              Privacidad
            </button>
            <button onClick={() => setTermsOpen(true)} className="text-xs sm:text-sm hover:text-white active:text-purple-100 transition-colors underline-offset-4 hover:underline py-1" data-id="element-6">
              Términos
            </button>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-7">
        <p className="text-gray-500 text-sm mb-6" data-id="element-8">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <h3 className="text-base sm:text-lg font-bold text-[#4C1D95] mt-6 mb-3" data-id="element-9">
          1. Información que Recopilamos
        </h3>
        <p className="mb-4 text-sm sm:text-base" data-id="element-10">
          Al adquirir nuestro ebook "Sanar en Movimiento", recopilamos
          únicamente la información necesaria para procesar tu compra:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-2 text-sm sm:text-base" data-id="element-11">
          <li data-id="element-12">Dirección de correo electrónico (para enviar el producto)</li>
          <li data-id="element-13">Información de pago (procesada de forma segura por terceros)</li>
        </ul>

        <h3 className="text-base sm:text-lg font-bold text-[#4C1D95] mt-6 mb-3" data-id="element-14">
          2. Uso de la Información
        </h3>
        <p className="mb-4 text-sm sm:text-base" data-id="element-15">
          Utilizamos tu información exclusivamente para:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-2 text-sm sm:text-base" data-id="element-16">
          <li data-id="element-17">Entregar el producto digital que has adquirido</li>
          <li data-id="element-18">Enviarte actualizaciones importantes sobre tu compra</li>
          <li data-id="element-19">Responder a consultas relacionadas con el producto</li>
        </ul>

        <h3 className="text-base sm:text-lg font-bold text-[#4C1D95] mt-6 mb-3" data-id="element-20">
          3. Protección de Datos
        </h3>
        <p className="mb-4 text-sm sm:text-base" data-id="element-21">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado, pérdida
          o alteración.
        </p>

        <h3 className="text-base sm:text-lg font-bold text-[#4C1D95] mt-6 mb-3" data-id="element-22">
          4. No Compartimos tu Información
        </h3>
        <p className="mb-4 text-sm sm:text-base" data-id="element-23">
          No vendemos, alquilamos ni compartimos tu información personal con
          terceros, excepto cuando sea necesario para procesar tu pago o cumplir
          con obligaciones legales.
        </p>

        <h3 className="text-base sm:text-lg font-bold text-[#4C1D95] mt-6 mb-3" data-id="element-24">
          5. Tus Derechos
        </h3>
        <p className="mb-4 text-sm sm:text-base" data-id="element-25">
          Tienes derecho a acceder, rectificar o eliminar tu información
          personal en cualquier momento.
        </p>

        <h3 className="text-base sm:text-lg font-bold text-[#4C1D95] mt-6 mb-3" data-id="element-26">
          6. Cookies
        </h3>
        <p className="mb-4 text-sm sm:text-base" data-id="element-27">
          Este sitio puede utilizar cookies esenciales para su funcionamiento.
          No utilizamos cookies de seguimiento publicitario.
        </p>
      </LegalModal>

      {/* Terms and Conditions Modal */}
      <LegalModal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-28">
        <p className="text-gray-500 text-sm mb-6" data-id="element-29">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <h3 className="text-base sm:text-lg font-bold text-[#4C1D95] mt-6 mb-3" data-id="element-30">
          1. Aceptación de los Términos
        </h3>
        <p className="mb-4 text-sm sm:text-base" data-id="element-31">
          Al comprar y utilizar "Sanar en Movimiento", aceptas estos términos y
          condiciones en su totalidad. Si no estás de acuerdo, por favor no
          realices la compra.
        </p>

        <h3 className="text-base sm:text-lg font-bold text-[#4C1D95] mt-6 mb-3" data-id="element-32">
          2. Naturaleza del Producto
        </h3>
        <p className="mb-4 text-sm sm:text-base" data-id="element-33">
          "Sanar en Movimiento" es un ebook educativo que proporciona
          información general sobre recuperación de lesiones. Este producto:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-2 text-sm sm:text-base" data-id="element-34">
          <li data-id="element-35">
            <strong data-id="element-36">NO es consejo médico</strong> ni sustituye la consulta con
            profesionales de la salud
          </li>
          <li data-id="element-37">NO diagnostica, trata ni cura ninguna condición médica</li>
          <li data-id="element-38">Está diseñado únicamente con fines informativos y educativos</li>
        </ul>

        <h3 className="text-base sm:text-lg font-bold text-[#4C1D95] mt-6 mb-3" data-id="element-39">
          3. Responsabilidad del Usuario
        </h3>
        <p className="mb-4 text-sm sm:text-base" data-id="element-40">
          Al utilizar este producto, reconoces que:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-2 text-sm sm:text-base" data-id="element-41">
          <li data-id="element-42">
            Debes consultar con un profesional de la salud antes de iniciar
            cualquier programa de ejercicios
          </li>
          <li data-id="element-43">
            Eres responsable de evaluar si las recomendaciones son apropiadas
            para tu situación específica
          </li>
          <li data-id="element-44">
            Cualquier acción que tomes basándote en el contenido es bajo tu
            propia responsabilidad
          </li>
        </ul>

        <h3 className="text-base sm:text-lg font-bold text-[#4C1D95] mt-6 mb-3" data-id="element-45">
          4. Propiedad Intelectual
        </h3>
        <p className="mb-4 text-sm sm:text-base" data-id="element-46">
          Todo el contenido de "Sanar en Movimiento" está protegido por derechos
          de autor. No está permitido:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-2 text-sm sm:text-base" data-id="element-47">
          <li data-id="element-48">Reproducir, distribuir o compartir el contenido</li>
          <li data-id="element-49">Modificar o crear obras derivadas</li>
          <li data-id="element-50">Usar el contenido con fines comerciales sin autorización</li>
        </ul>

        <h3 className="text-base sm:text-lg font-bold text-[#4C1D95] mt-6 mb-3" data-id="element-51">
          5. Política de Reembolso
        </h3>
        <p className="mb-4 text-sm sm:text-base" data-id="element-52">
          Ofrecemos una garantía de satisfacción de 7 días. Si el producto no
          cumple tus expectativas, puedes solicitar un reembolso completo dentro
          de este período.
        </p>

        <h3 className="text-base sm:text-lg font-bold text-[#4C1D95] mt-6 mb-3" data-id="element-53">
          6. Limitación de Responsabilidad
        </h3>
        <p className="mb-4 text-sm sm:text-base" data-id="element-54">
          En la máxima medida permitida por la ley, no seremos responsables por
          daños directos, indirectos, incidentales o consecuentes derivados del
          uso de este producto.
        </p>

        <h3 className="text-base sm:text-lg font-bold text-[#4C1D95] mt-6 mb-3" data-id="element-55">
          7. Modificaciones
        </h3>
        <p className="mb-4 text-sm sm:text-base" data-id="element-56">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Los cambios entrarán en vigor inmediatamente después de su
          publicación.
        </p>
      </LegalModal>
    </>;
}